import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import {
  DisconnectAccountFromFornaxMutation,
  RequestConnectAccountToFornaxMutation,
} from '../../../gql/graphql';

const REQUEST_CONNECT_ACCOUNT_TO_FORNAX = graphql(`
  mutation RequestConnectAccountToFornax {
    requestConnectAccountToFornax
  }
`);

export const useRequestConnectAccountToFornax = (
  options?: UseMutationOptions<RequestConnectAccountToFornaxMutation, unknown>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => gqlClient.request(REQUEST_CONNECT_ACCOUNT_TO_FORNAX),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: meKeys.integrations(),
      }),
    ...options,
  });
};

const DISCONNECT_ACCOUNT_FROM_FORNAX = graphql(`
  mutation DisconnectAccountFromFornax {
    disconnectAccountFromFornax
  }
`);

export const useDisconnectAccountFromFornax = (
  options?: UseMutationOptions<DisconnectAccountFromFornaxMutation, unknown>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => gqlClient.request(DISCONNECT_ACCOUNT_FROM_FORNAX),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: meKeys.integrations(),
      }),
    ...options,
  });
};
